import { render, staticRenderFns } from "./RejectSuccessModal.vue?vue&type=template&id=54db29d5&"
import script from "./RejectSuccessModal.vue?vue&type=script&lang=js&"
export * from "./RejectSuccessModal.vue?vue&type=script&lang=js&"
import style0 from "./RejectSuccessModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports